import React, { Component } from 'react';
import * as UiConsts from '../../../../config/UiConstants';
import { toCurrency, pythonApiIp } from '../../../../config/constants.js'
import axios from 'axios'
import { Button, Form, Header, Divider } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

class ViewReceiptOnPoject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            receipts: [],
            loading: false,
        }
    }

    componentDidMount() {
        console.log("getrx1 ++++++ componentDidMount ");

    }


    getReceipt = (recNum) => {
        console.log("getRx12 ++++++ getReceipt ");

        this.setState({ loading: true });

        axios.post(pythonApiIp + 'getReceiptsOnProject', {
            apiKey: "ad#4fsdUUddf",
            projectId: this.props.projectId
        })
            .then((response) => {
                console.log(JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                    this.setState({
                        receipts: response.data.receipts,
                    });
                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                this.setState({ loading: false });
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    viewReceipts = () => {
        console.log("+++++++ viewReceipts ++++++")
        this.getReceipt();
    }

    render() {

        const receipts = this.state.receipts.length > 0
        ? this.state.receipts.map((receipt, index) =>
            <h4 key={receipt.idreceiptsonprojects}><div>
                <Link to={'/dashboard/viewReceipt/' + receipt.receipt.recieptnum} target="_blank">VIEW RECEIPT - {receipt.receipt.recieptnum} </Link>
                <br/>Amount Rec: {toCurrency(receipt.receipt.amountrec)}
                <br/>Amount Dep: {toCurrency(receipt.receipt.amountdep)}
                <br/>Delivered: {receipt.receipt.dadate}
                <br/>Date Entered: {receipt.datetimeadded}
                <br/>Entered By: {receipt.receipt.adminemail}<br/>
                </div></h4>
        )
        :<h4> No Receipts</h4>

        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>
                <Divider horizontal>{'RECEIPT INFO'}</Divider>
                <Button fluid color='pink' onClick={this.getReceipt}>View Receipts</Button>
                {receipts}

            </div>);
    }
}

export default ViewReceiptOnPoject;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewReceiptOnPoject.js